import Experience from '../Experience.js'
import Environment from './Environment.js'
import Page from './Page.js'
import gsap from 'gsap'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.camera = this.experience.camera;
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.html = this.experience.html
        this.sound = this.experience.sound
        this.debug = this.experience.debug.panel

        // Loading UI elements
        this.percentEl = document.getElementById('loading-percent')
        this.sizeEl = document.getElementById('loading-size')

        this.displayPercent = 0
        this.displayPercentBytes = 0

        this.resources.on('progress', (data) => {
            this.displayPercent = data.percent
            this.loadedBytes = data.loadedBytes || 0
            this.totalBytes = data.totalBytes || 0
        })

        // Wait for resources
        this.resources.on('ready', () =>
        {

            this.experience.time.start = Date.now()
            this.experience.time.elapsed = 0

            // Setup
            this.page = new Page()
            this.environment = new Environment()

            // Remove preloader & loading percent
            this.html.preloader.classList.add("preloaded");
            this.html.preloader.remove();
            if (this.percentEl) this.percentEl.remove();
            if (this.sizeEl) this.sizeEl.remove();

            // Particle fly-in entrance: animate both sim and render materials
            const entranceObj = { value: 0 };
            gsap.to(entranceObj, {
                value: 1,
                duration: 2.0,
                ease: 'power3.inOut',
                delay: 0.2,
                onUpdate: () => {
                    this.page.simMaterial.uniforms.uEntrance.value = entranceObj.value;
                    this.page.renderMaterial.uniforms.uEntrance.value = entranceObj.value;
                }
            });

            // Text entrance animation
            const firstSection = document.querySelector('.section:first-child');
            if (firstSection) {
                const h2 = firstSection.querySelector('h2');
                const p = firstSection.querySelector('p');
                if (h2) {
                    h2.style.opacity = '0';
                    h2.style.transform = 'translateY(40px)';
                }
                if (p) {
                    p.style.opacity = '0';
                    p.style.transform = 'translateY(30px)';
                }
                // Force reflow then animate with GSAP
                firstSection.offsetHeight;
                if (h2) {
                    gsap.to(h2, { opacity: 1, y: 0, duration: 1.0, ease: 'power3.out', delay: 0.5 });
                }
                if (p) {
                    gsap.to(p, { opacity: 1, y: 0, duration: 1.0, ease: 'power3.out', delay: 0.7 });
                }
            }

            // Animation timeline
            this.animationPipeline();
        })
    }

    animationPipeline() {
        // if ( this.text )
        //     this.text.animateTextShow()

        if ( this.camera )
            this.camera.animateCameraPosition()
    }

    resize() {
        this.page.resize()
    }

    scroll()
    {
        if ( this.page )
            this.page.scroll()
    }

    update()
    {
        // Direct loading progress (actual bytes)
        if (this.displayPercent > 0 && this.displayPercent < 100) {
            if (this.percentEl) {
                this.percentEl.textContent = this.displayPercent + '%'
            }
            if (this.sizeEl) {
                const dlMB = (this.loadedBytes / 1048576).toFixed(1)
                const totalMB = (this.totalBytes / 1048576).toFixed(1)
                this.sizeEl.textContent = dlMB + ' MB / ' + totalMB + ' MB'
            }
        }

        if(this.page)
            this.page.update()
    }
}
